import { createFileRoute } from "@tanstack/react-router";
import { Megaphone } from "@phosphor-icons/react";
import { ReportBreadcrumb } from "../../components/reports/ReportBreadcrumb";

export const Route = createFileRoute("/_authenticated/whats-new")({
  component: WhatsNewPage,
});

function WhatsNewPage() {
  return (
    <div className="p-6 max-w-[1100px] mx-auto">
      <ReportBreadcrumb items={[{ label: "What's new" }]} />

      <div className="mt-2 mb-8">
        <h1 className="text-[22px] font-semibold text-foreground">What's new</h1>
        <p className="text-[13px] text-muted-foreground mt-1">
          Latest features, improvements, and announcements from the
          ProvenLeap team.
        </p>
      </div>

      <div
        className="rounded-[22px] bg-background p-12 shadow-xs text-center"
        style={{ border: "0.5px solid var(--hairline)" }}
      >
        <div className="mx-auto flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 mb-4">
          <Megaphone size={28} className="text-primary" />
        </div>
        <h2 className="text-[15px] font-semibold text-foreground">
          Changelog is on the way
        </h2>
        <p className="text-[13px] text-muted-foreground mt-2 max-w-md mx-auto">
          Soon you'll find a curated stream of new features, integrations,
          and improvements right here. No more wondering what changed —
          we'll show you.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-muted/50 px-3 py-1 text-[12px] text-muted-foreground">
          <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
          Coming soon
        </div>
      </div>
    </div>
  );
}
